export const STORES = {
  AUTH: "AUTH",
  STUFFS: "STUFFS",
  NOTIFICATIONS: "NOTIFICATIONS",
  CATEGORIES: "CATEGORIES",
  OWNERS: "OWNERS",
  AUCTIONS: "AUCTIONS",
  ANALYTICS: "ANALYTICS",
  EXHIBITIONS: "EXHIBITIONS",
  SHOWROOMS: "SHOWROOMS",
  SHOWROOMS_ITEMS: "SHOWROOMS_ITEMS",
  SOUQ: "SOUQ",
  REALESTATE: "REALESTATE",
  REFUNDS: "REFUNDS",
PREFS: "PREFS",
  CUSTOMERS: "CUSTOMERS",
  BIDDING: "BIDDING",
  DIRECT_SALE: "DIRECT_SALE"
}
